/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <Card>
    <Toolbar class="sub-header ag-sub-header">
      <div class="mr-4 subheading">
        {{ $t(graphName) }}
      </div>
      <v-spacer></v-spacer>
      <div class="body-1">
        {{ showDate }}
      </div>
    </Toolbar>
    <v-container class="ag-graph">
      <v-layout row wrap align-content-space-between>
        <v-flex xs6 lg2>
          <Select :label="$t('Select Graph')" :items="graphCategoryList" :selection="graphCategory"
            :itemText="'text'" :itemValue="'value'" @change="graphChangeHandler" />
        </v-flex>
        <v-flex xs6 lg2>
          <Select v-if="showGraphType" :label="$t('Graph Type')"
            :items="graphTypeList" :selection="graphType"
            :itemText="'text'" :itemValue="'value'" 
            @change="(g) => graphType = g" />
        </v-flex>

        <v-flex xs12 md6 class="toggle-position" align-self-center>
          <Toggle v-if="showYieldToggle"
            :theme="theme"
            :modelValue="plantYield"
            @toggleValueChange="(val) => plantYield = val">
            <v-btn flat value="energy">{{ $t('Energy') }}</v-btn>
            <v-btn flat value="yield">{{ $t('Yield') }}</v-btn>
          </Toggle>
        </v-flex>
      </v-layout>
      <div class="graph">
        <component :is="selectedComponent" :blockLevel="isBlockLevel" :graph="graphCategory"
          :date="fullDate" :type="graphType" :blockId="blockIdSelected"
          :invRoom="selectedInvRoom" :plantYield="plantYield" :isMultipleDays="isMultipleDays">
        </component>
      </div>
    </v-container>
  </Card>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/services/event-bus'
import { mixin, mapGettersMixin } from '@/util/mixin/index'
const plantGeneration = () =>
  import('@/components/dashboard-inverter/PlantGeneration')
const plantPower = () => import('@/components/dashboard-inverter/PlantPower')
const plantEnergy = () => import('@/components/dashboard-inverter/PlantEnergy')
const Toolbar = () => import('@/components/common/Toolbar')
const moment = require('moment')

export default {
  components: {
    plantGeneration,
    plantPower,
    plantEnergy,
    Toolbar
  },
  props: ['fullDate'],
  mixins: [mixin, mapGettersMixin],
  data() {
    return {
      blockIdSelected: null,
      selectedInvRoom: null,
      isBlockLevel: true,
      plantYield: 'energy',
      selectedComponent: 'plantEnergy',
      graphCategory: 'Energy',
      graphType: 'Total',
      isMultipleDays: false
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getGeneralState']),
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    showDate() {
      return `${moment(this.fullDate[0]).format('YYYY/M/D')} - ${moment(
        this.fullDate[1]
      ).format('YYYY/M/D')}`
    },
    graphName() {
      return this.graphCategory === 'Energy'
        ? 'Generation Graph'
        : `${this.graphCategory} Graph`
    },
    showYieldToggle() {
      return (
        this.isMultipleDays &&
        this.graphCategory === 'Energy' &&
        !this.isBlockLevel
      )
    },
    showGraphType() {
      return !this.isBlockLevel && this.graphCategory !== 'Plant Total'
    },
    graphCategoryList() {
      return [
        {
          text: this.$t('Plant Total'),
          value: 'Plant Total'
        },
        {
          text: this.$t('Energy'),
          value: 'Energy'
        },
        {
          text: this.$t('Power'),
          value: 'Power'
        }
      ]
    },
    graphTypeList() {
      return [{
        text: this.$t('Total'),
        value: 'Total'
      }, {
        text: this.$t('Inverter Wise'),
        value: 'Inverter Wise'
      }]
    }
  },
  created() {
    EventBus.$on('change:level', this.levelChanged)
  },
  beforeDestroy() {
    EventBus.$off('change:level', this.levelChanged)
  },
  methods: {
    levelChanged(payload) {
      // TODO: MARK CHANGED
      this.isBlockLevel = payload.level === 'block'
      if (payload.level === 'room') {
        this.blockIdSelected = payload.id.split('-')[0]
        this.selectedInvRoom = payload.id.split('-')[1]
      } else {
        this.blockIdSelected = payload.id
        this.selectedInvRoom = null
      }
    },
    graphChangeHandler(graph) {
      this.graphCategory = graph
      switch (graph.toLowerCase()) {
        case 'energy':
          this.selectedComponent = plantEnergy
          break
        case 'power':
          this.selectedComponent = plantPower
          break
        default:
          this.selectedComponent = plantGeneration
          break
      }
    }
  },
  watch: {
    getSelectedPlantId() {
      this.graphCategory = 'Energy'
      this.graphType = 'Total'
    },
    fullDate() {
      if (
        this.dateValidate(this.fullDate[0]) &&
        this.dateValidate(this.fullDate[1])
      ) {
        if (this.fullDate[0] === this.fullDate[1]) {
          this.isMultipleDays = false
        } else {
          this.isMultipleDays = true
        }
      } else {
        this.alertMessage = 'Please select a valid date'
        this.snackbar = true
      }
    }
  }
}
</script>

<style scoped>
  .graph {
    width: 100%;
    height: 520px;
  }

.toggle-position {
  text-align: center;
}

</style>
